import { render } from "./ProfileOrderTable.vue?vue&type=template&id=32ed95de"
import script from "./ProfileOrderTable.vue?vue&type=script&lang=js"
export * from "./ProfileOrderTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/frontend/js/components/ProfileOrderTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "32ed95de"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('32ed95de', __exports__)) {
    api.reload('32ed95de', __exports__)
  }
  
  module.hot.accept("./ProfileOrderTable.vue?vue&type=template&id=32ed95de", () => {
    api.rerender('32ed95de', render)
  })

}


export default __exports__